import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';

/**
 * Use this to get the ab test variation.
 * This hook uses window.VWO global func so you must be sure that the current page is loading the vwo script.
 */
function useABTest(testId, skip) {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState('1'),
    _useState4 = _slicedToArray(_useState3, 2),
    ABVariation = _useState4[0],
    setABVariation = _useState4[1];
  useEffect(function () {
    if (!skip) {
      // @ts-ignore
      window.VWO = window.VWO || [];
      // @ts-ignore
      window._vwo_evq = window._vwo_evq || [];

      // URL is part of an a/b test
      // @ts-ignore
      window.VWO.push(['onEventReceive', 'vA',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      function (vwoData) {
        // To fetch A/B test id
        var experimentId = vwoData[1];

        // To fetch A/B test active variation name
        var variationId = vwoData[2];
        if (
        // @ts-ignore
        typeof window._vwo_exp[experimentId].comb_n[variationId] !== 'undefined' && ['VISUAL_AB', 'VISUAL', 'SPLIT_URL', 'SURVEY'].indexOf(
        // @ts-ignore
        window._vwo_exp[experimentId].type) > -1) {
          var TEST_ID = testId;
          if (experimentId === TEST_ID) {
            setABVariation(variationId);
            setLoading(false);
          }
        }
      }]);
    }
  }, []);
  useEffect(function () {
    var loadingTime = setTimeout(function () {
      setLoading(false);
    }, 1000);
    return function () {
      return clearTimeout(loadingTime);
    };
  }, []);
  return {
    ABVariation: ABVariation,
    loading: loading
  };
}
export default useABTest;